<script lang="ts" setup>
const props = defineProps({
  active: {
    default: false,
    type: Boolean,
  },
  badgePosition: {
    default: 'bottom',
    type: String,
  },
  clickable: {
    default: false,
    type: Boolean,
  },
  icon: {
    default: '',
    type: String,
  },
  isPower: {
    default: false,
    type: Boolean,
  },
  title: {
    default: '',
    type: String,
  },
})

const emit = defineEmits<{
  click: []
}>()

const { t } = useI18n()

const rootRef = ref<HTMLDivElement>()

function onClick() {
  if (props.clickable) {
    emit('click')
  }
}

defineExpose({ rootRef })
</script>

<template>
  <div
    ref="rootRef"
    class="group relative z-10 transform cursor-pointer select-none transition-all hover:scale-105"
    :class="{
      'scale-105': active,
      'pointer-events-none': !clickable,
    }"
    @click="onClick"
  >
    <UButton
      class="gradient-texture-light flex size-16 items-center justify-center rounded-full bg-gray-100 p-3 shadow-sm ring-2 ring-inset transition-all hover:bg-gray-100 focus-visible:ring-indigo-600 dark:bg-gray-900 hover:dark:bg-gray-900 dark:focus-visible:ring-indigo-400"
      :class="{
        'ring-gray-300 dark:ring-gray-700': !active,
        'group-hover:ring-gray-400 dark:group-hover:ring-gray-600': !active && clickable,
        'ring-indigo-500 dark:ring-indigo-400': active,
      }"
      variant="ghost"
    >
      <UIcon
        v-if="icon"
        class="size-8 text-gray-900 dark:text-gray-100"
        :name="icon"
      />

      <BaseCharacter
        v-if="isPower"
        character="power"
      />
    </UButton>

    <UBadge
      class="absolute whitespace-nowrap transition-all"
      :class="{
        'group-hover:text-gray-900 group-hover:ring-gray-400 dark:group-hover:text-gray-100 dark:group-hover:ring-gray-700': !active && clickable,
        '-top-5 left-1/2 -translate-x-1/2': badgePosition === 'top',
        '-bottom-5 left-1/2 -translate-x-1/2': badgePosition === 'bottom',
      }"
      color="indigo"
      size="xs"
      :variant="active ? 'solid' : 'subtle'"
    >
      <template v-if="title">
        {{ title }}
      </template>

      <template v-else-if="isPower">
        {{ t('globals.power') }}
      </template>
    </UBadge>
  </div>
</template>
